import React from 'react'
import useSEO from "./useSEO";

const Focusaccountingsoftware = () => {

  useSEO({ 
    title: "Focus Accounting Software | Smart Business Accounting & GST Solution",
    description: "Focus Accounting Software helps businesses manage finance, GST, inventory, payroll, and reporting with automation and real-time insights.",
    keywords: "Focus accounting software, Focus ERP accounting, GST accounting software India, inventory accounting system, business finance management software",
    ogTitle: "Focus Accounting Software - Complete Business Finance Solution",
    ogDescription: "Simplify accounting, GST filing, reporting, and inventory with Focus Accounting Software.",
    ogImage: "img/opticon-accounting.png",
    twitterTitle: "Focus Accounting Software - Smart Finance Management",
    twitterDescription: "Manage accounting, GST, inventory, and reports easily with Focus.",
    twitterImage: "img/opticon-accounting.png"
  });

  return (
    <div>
      <>
        <section className="pt-lg-8 pt-xl-9">
          <div className="container position-relative pt-4 pt-lg-0">
            <div className="row align-items-center">

              {/* Title */}
              <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
                <h1 className="mb-4">Focus Accounting Software</h1>

                <p className="mb-4">
                  Focus Accounting Software is a powerful financial management
                  solution designed to help modern businesses automate their
                  accounting operations, maintain compliance, and gain complete
                  visibility into financial performance. From small businesses
                  to large enterprises, Focus simplifies complex accounting
                  processes and helps organizations make better financial
                  decisions.
                </p>

                <p>
                  With built-in GST compliance, inventory tracking, smart
                  reporting, and seamless integrations, Focus enables companies
                  to manage their finances faster, more accurately, and with
                  greater control. The platform is intuitive, scalable, and
                  built to support growing business needs.
                </p>
              </div>

              {/* Image */}
              <div className="col-md-5 ms-auto">
                <img
                  src="img/focus-accounting.png"
                  alt="Focus Accounting Software"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="overflow-hidden pb-0">
          <div className="container">
            <div className="row align-items-center">

              {/* Image */}
              <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
                <div className="pe-lg-6 pe-xl-8">
                  <img
                    src="img/focus-accounting-software.jpg"
                    alt="Focus Accounting Dashboard"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="col-lg-6 ms-auto">

                <h2 className="mb-lg-4">Key Features</h2>
                <hr className="my-4 my-lg-5" />

                <div className="row">
                  <div className="col-sm-12">

                    <ul className="list-group list-group-borderless">

                      <li className="list-group-item heading-color fw-normal d-flex mb-0">
                        <i className="bi bi-patch-check text-primary me-2" />
                        <b>Complete Financial Management</b>
                      </li>
                      <p>
                        Manage general ledger, accounts payable, receivable,
                        journal entries, and bank reconciliation in a single
                        system designed for accuracy and efficiency.
                      </p>

                      <li className="list-group-item heading-color fw-normal d-flex mb-0">
                        <i className="bi bi-patch-check text-primary me-2" />
                        <b>GST & Tax Compliance</b>
                      </li>
                      <p>
                        Create GST-ready invoices, generate tax reports,
                        and simplify return filing while staying compliant with
                        the latest regulations.
                      </p>

                      <li className="list-group-item heading-color fw-normal d-flex mb-0">
                        <i className="bi bi-patch-check text-primary me-2" />
                        <b>Inventory & Billing</b>
                      </li>
                      <p>
                        Track stock levels, manage warehouses, automate billing,
                        and monitor purchases and sales in real time.
                      </p>

                      <li className="list-group-item heading-color fw-normal d-flex mb-0">
                        <i className="bi bi-patch-check text-primary me-2" />
                        <b>Multi-User Access Control</b>
                      </li>
                      <p>
                        Assign roles and permissions to employees while keeping
                        financial data secure and organized.
                      </p>

                      <li className="list-group-item heading-color fw-normal d-flex mb-0">
                        <i className="bi bi-patch-check text-primary me-2" />
                        <b>Advanced Reporting & Analytics</b>
                      </li>
                      <p>
                        Access real-time reports including profit & loss,
                        balance sheet, trial balance, tax summaries, and
                        business insights.
                      </p>

                      <li className="list-group-item heading-color fw-normal d-flex mb-0">
                        <i className="bi bi-patch-check text-primary me-2" />
                        <b>Smart Dashboard</b>
                      </li>
                      <p>
                        View financial performance, cash flow, receivables,
                        and business KPIs from a centralized dashboard.
                      </p>

                    </ul>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </>
    </div>
  )
}

export default Focusaccountingsoftware